// initial state
const state = {
  all: null,
  error: 0
}

// getters
const getters = {
  userHistory: state => state.all
}

// actions
const actions = {
  getUserHistory ({ commit }, data) {
    commit('setUserHistory', data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

// mutations
const mutations = {
  setUserHistory (state, all) {
    state.all = all
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
